import Swiper from "swiper";
// import { Pagination } from "swiper";
import "swiper/css/pagination";

$(() => {
  const swiperKeywords = new Swiper(".swiper.swiper__keywords", {
    modules: [Pagination],
    slidesPerView: "auto",
    pagination: {
      el: ".swiper__keywords .swiper-pagination",
      clickable: true,
    },
  });

  // Function to set the specified slide as active
  function setActiveSlide(index) {
    swiperKeywords.slideTo(index); // Use the slideTo method to set the active slide
  }

  $(".book__spine").click(function () {
    if ($(this).closest(".book").hasClass("open")) {
      $(this).next().animate({ width: "hide" });
      $(this).closest(".book").removeClass("open");
    } else {
      $(".book").removeClass("open");
      $(".book__content").animate({ width: "hide" });
      $(this).next().animate({ width: "toggle" });
      $(this).closest(".book").toggleClass("open");
    }

    const curIndex = $(this).closest(".swiper-slide").index();

    setTimeout(function () {
      swiperKeywords.update();
      setActiveSlide(curIndex);
    }, 350);
  });

});
document.addEventListener('DOMContentLoaded', (event) => {
  document.body.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      // alert('右鍵被禁用');
  });
});